import { render, staticRenderFns } from "./ProductContentClasses.vue?vue&type=template&id=83dac18e&scoped=true"
import script from "./ProductContentClasses.vue?vue&type=script&lang=js"
export * from "./ProductContentClasses.vue?vue&type=script&lang=js"
import style0 from "./ProductContentClasses.vue?vue&type=style&index=0&id=83dac18e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83dac18e",
  null
  
)

export default component.exports